import React from "react"
import { useSiteMetadata } from "../hooks/use-site-metadata"

import favicon from '../images/clearout_favicon.ico'


export const Seo = ({ title, description, pathname, children, keywords, socialImagePath }) => {
    const { title: defaultTitle, description: defaultDescription, siteUrl, keywords: defaultKeywords, socialImagePath : defaultSocialImagePath } = useSiteMetadata()

    const seo = {
        title: title || defaultTitle,
        description: description || defaultDescription,
        keywords: keywords || defaultKeywords,
        url: `${siteUrl+`/`}${pathname || ``}`,
        socialImageUrl: `${siteUrl}${socialImagePath || defaultSocialImagePath}`
    }

    // console.debug('children:', title, children, seo)

    return (
        <>
            {/* <!-- Primary Meta Tags --> */}
            <title>{seo.title}</title>
            <meta name="title" content={seo.title} />
            <meta name="description" content={seo.description} />
            <meta name="keywords" content={seo.keywords} />
            {/* <!-- Open Graph / Facebook --> */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={seo.url} />
            <meta property="og:title" content={seo.title} />
            <meta property="og:description" content={seo.description} />
            <meta property="og:image" content={seo.socialImageUrl} />

            {/* <!-- Twitter --> */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={seo.url} />
            <meta property="twitter:title" content={seo.title} />
            <meta property="twitter:description" content={seo.description} />
            <meta property="twitter:image" content={seo.socialImageUrl} />

            {/* favicon */}
            <link rel="shortcut icon" href={favicon}></link>

            {/* children nodes */}
            {children}
        </>
    )
}